import React from "react";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import classNames from "classnames";
import { ReferalsResponse } from "@/types/referals";
import cls from "./styles.module.scss";

interface PaginationProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  list: ReferalsResponse;
}

export const Pagination = ({
  currentPage,
  onPageChange,
  list,
}: PaginationProps) => {
  const referalsPerPage = list.limit;
  const totalCount = list?.count || list?.total;
  const totalPages = Math.ceil(totalCount / referalsPerPage);

  const indexOfLast = currentPage * referalsPerPage;
  const indexOfFirst = indexOfLast - referalsPerPage;

  const getVisiblePages = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage === 1) return [1, 2, 3];
    if (currentPage === totalPages)
      return [totalPages - 2, totalPages - 1, totalPages];

    return [currentPage - 1, currentPage, currentPage + 1];
  };

  const visiblePages = getVisiblePages();

  return (
    totalPages > 1 && (
      <FlexRow justifyContent="space-between">
        <div className={cls.pages}>
          {indexOfFirst + 1} –{" "}
          {indexOfLast >= totalCount ? totalCount : indexOfLast} из {totalCount}
        </div>

        <FlexRow gap={4}>
          <button
            type="button"
            data-trigger="ref.pagination.previous"
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
            className={cls.pageBtn}
          >
            ‹
          </button>

          {visiblePages.map((page) => (
            <button
              key={page}
              type="button"
              data-trigger="ref.pagination.page"
              onClick={() => onPageChange(page)}
              className={classNames(
                cls.pageBtn,
                currentPage === page ? cls.activePage : undefined
              )}
            >
              {page}
            </button>
          ))}

          <button
            type="button"
            data-trigger="ref.pagination.next"
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
            className={cls.pageBtn}
          >
            ›
          </button>
        </FlexRow>
      </FlexRow>
    )
  );
};
